// Invitations from coaches, as the athlete answers them.
//
// Pure logic only; CoachInvitationsCard.js renders it.
//
// # WHY THE CARD SPELLS OUT WHAT IS SHARED
//
// Accepting is consent, and consent to something unnamed is not worth much. A
// coach's overview (routes/rollup.go, GetRosterOverview) shows exactly the
// things listed in SHARED_WITH_COACH, and the rest of what a coach can do is in
// COACH_CAN. If that endpoint starts showing something new, this list is the
// promise it breaks — change both together.

/** What a coach sees about an athlete who accepts. */
export const SHARED_WITH_COACH = [
  'How you rated your sleep, soreness, stress and energy today, and any note you add to it',
  'The days you train, how many sets you logged this week, and sessions due or overdue',
  'The names of the programmes you are on',
];

/** What a coach can do once accepted. */
export const COACH_CAN = 'They can also give you programmes and add you to their squad calendars.';

/** What they cannot see — the reassurance that matters most. */
export const NOT_SHARED = 'They do not see the weights you lift, your maxes, or your set-by-set history.';

/**
 * The invitations in a GET /coach-invitations response.
 *
 * Tolerates a missing body and drops anything without an id: an entry that
 * cannot be answered must not render buttons that 404.
 */
export function invitationsFrom(data) {
  const list = Array.isArray(data?.invitations) ? data.invitations : [];
  return list.filter((inv) => Number(inv?.id) > 0);
}

/** The card heading for one invitation. */
export function invitationHeading(invitation) {
  const coach = String(invitation?.coachUsername ?? '').trim();
  return coach ? `${coach} wants to coach you` : 'A coach wants to coach you';
}

/** What the athlete is told once they have answered. */
export function answeredMessage(invitation, accepted) {
  const coach = String(invitation?.coachUsername ?? '').trim() || 'the coach';
  return accepted
    ? `You are on ${coach}'s roster.`
    : `Declined. ${coach} is not told, and sees nothing of yours.`;
}

/** Everything except the invitation just answered. */
export function withoutInvitation(list, id) {
  return (list ?? []).filter((inv) => inv.id !== id);
}
